module.exports = __webpack_public_path__ + "assets/img/11.641b9103.png";